import susanaProfile from '../assets/susanaProfile.webp'
import raduProfile from '../assets/raduProfile.webp'
import dimitriosProfile from '../assets/dimitriosProfile.webp'

// Témoignages de praticiens RECRUTÉS — la preuve la plus forte pour un
// candidat qui envisage de déménager ou s'expatrier : quelqu'un qui l'a fait.
// Verbatims validés avec Hadrien (16/08/2026), cohérents avec leurs bios
// publiques sur oasissante.fr.
const TESTIMONIALS = (isEnglish) => [
    {
        img: susanaProfile,
        flag: '🇵🇹',
        name: 'Dr Susana Coelho',
        sub: isEnglish
            ? 'General dentist — joined from the UK, December 2025'
            : 'Omnipraticienne — arrivée du Royaume-Uni en décembre 2025',
        quote: isEnglish
            ? '"After my career in Portugal and more than ten years in the UK, I have found my rhythm here. I work the way that suits me, with an assistant who truly helps chairside — and I have just bought my own home in Châteauroux. The in-house lab opening is great news."'
            : '« Après ma carrière au Portugal puis plus de dix ans au Royaume-Uni, j\'ai trouvé mon rythme ici. Je travaille à ma façon, avec une assistante qui m\'aide vraiment au fauteuil — et je viens d\'acheter mon logement à Châteauroux. L\'ouverture de notre laboratoire interne est une super nouvelle. »',
    },
    {
        img: raduProfile,
        flag: '🇷🇴',
        name: 'Dr Radu Zaharii',
        sub: isEnglish
            ? 'General dentist, endodontics — joined December 2025'
            : 'Omnipraticien, endodontie — arrivé en décembre 2025',
        quote: isEnglish
            ? '"I arrived with a strong endodontics background and developed my practice exactly as I intended — including getting trained in implantology with the team. My wife has since joined us as a dentist too: that says how much the model convinced me."'
            : '« Je suis arrivé avec une expertise forte en endodontie et j\'ai développé mon exercice exactement comme je l\'entendais — jusqu\'à me former à l\'implantologie avec l\'équipe. Mon épouse nous a depuis rejoints comme dentiste : c\'est dire si le modèle m\'a convaincu. »',
    },
    {
        img: dimitriosProfile,
        flag: '🇬🇷',
        name: 'Dr Dimitrios Lianos',
        sub: isEnglish
            ? 'General dentist, implantology — joined March 2026'
            : 'Omnipraticien, implantologie — nous a rejoints en mars 2026',
        quote: isEnglish
            ? '"At my previous position in Lyon: not enough staff and equipment, failing organisation, and no way to reach management to fix things. Here the organisation truly delivers, I am free to shape my practice — and my revenue is up 50% on average."'
            : '« À mon poste précédent à Lyon : moyens humains et matériels insuffisants, organisation défaillante, et impossible d\'accéder à la direction pour régler les problèmes. Ici l\'organisation suit vraiment, je suis libre d\'orienter mon exercice — et mon chiffre d\'affaires a progressé de 50 % en moyenne. »',
    },
]

export default function Testimonials({ isEnglish }) {
    return (
        <div className="px-4 sm:px-20 mt-14 sm:mt-24">
            <div className="text-center mb-8 sm:mb-10">
                <h3 className="text-md md:text-xl font-semibold leading-7 text-brand-600">
                    {isEnglish ? 'THEY MADE THE MOVE' : 'ILS ONT SAUTÉ LE PAS'}
                </h3>
                <h2 className="mb-2 md:mt-1 text-2xl sm:text-3xl font-bold md:text-4xl tracking-tight text-gray-900">
                    {isEnglish ? 'Three practitioners, three journeys' : 'Trois praticiens, trois parcours'}
                </h2>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 sm:gap-6">
                {TESTIMONIALS(isEnglish).map((t) => (
                    <figure key={t.name} className="flex flex-col rounded-2xl bg-white p-6 sm:p-8 shadow-xl border border-gray-100">
                        <blockquote className="flex-1 text-sm sm:text-base leading-7 text-gray-700">
                            {t.quote}
                        </blockquote>
                        <figcaption className="mt-6 flex items-center gap-4">
                            <img
                                src={t.img}
                                alt={t.name}
                                loading="lazy"
                                className="h-14 w-14 rounded-full object-cover object-top ring-2 ring-brand-100"
                            />
                            <div>
                                <div className="font-bold text-gray-900">{t.flag} {t.name}</div>
                                <div className="text-xs sm:text-sm text-gray-500">{t.sub}</div>
                            </div>
                        </figcaption>
                    </figure>
                ))}
            </div>
        </div>
    )
}
